const WEEKEND_STATUS_LABEL = "Weekend Present";

const WEEKEND_DATE_FORMATS = [
  /^(\d{2})-(\d{2})-(\d{4})$/,
  /^(\d{4})-(\d{2})-(\d{2})$/,
];

const normalizeStatusLabel = (status) => {
  const trimmedStatus = String(status || "").trim();

  if (!trimmedStatus) {
    return trimmedStatus;
  }

  if (trimmedStatus.toLowerCase() === "comes late") {
    return "Late";
  }

  if (trimmedStatus.toLowerCase() === "weekend present") {
    return WEEKEND_STATUS_LABEL;
  }

  return trimmedStatus;
};

const parseAttendanceDate = (dateValue) => {
  const trimmedDate = String(dateValue || "").trim();

  if (!trimmedDate) {
    return null;
  }

  const ddMmYyyyMatch = trimmedDate.match(WEEKEND_DATE_FORMATS[0]);
  if (ddMmYyyyMatch) {
    const [, day, month, year] = ddMmYyyyMatch;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const yyyyMmDdMatch = trimmedDate.match(WEEKEND_DATE_FORMATS[1]);
  if (yyyyMmDdMatch) {
    const [, year, month, day] = yyyyMmDdMatch;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const parsedDate = new Date(trimmedDate);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const isWeekendDate = (dateValue) => {
  const parsedDate = parseAttendanceDate(dateValue);

  if (!parsedDate) {
    return false;
  }

  const day = parsedDate.getDay();
  return day === 0 || day === 6;
};

const hasClockInTime = (timeValue) => {
  const trimmedTime = String(timeValue || "").trim();
  return Boolean(trimmedTime && trimmedTime !== "--" && trimmedTime.toLowerCase() !== "n/a");
};

const parseDurationToMinutes = (durationValue) => {
  const trimmedDuration = String(durationValue || "").trim().toLowerCase();

  if (!trimmedDuration || trimmedDuration === "--" || trimmedDuration === "n/a") {
    return 0;
  }

  let totalMinutes = 0;

  const hourMatch = trimmedDuration.match(/(\d+(?:\.\d+)?)\s*(hour|hours|hr|hrs|h)\b/i);
  const minuteMatch = trimmedDuration.match(/(\d+(?:\.\d+)?)\s*(minute|minutes|min|mins|m)\b/i);
  const secondMatch = trimmedDuration.match(/(\d+(?:\.\d+)?)\s*(second|seconds|sec|secs|s)\b/i);

  if (hourMatch || minuteMatch || secondMatch) {
    const hours = hourMatch ? parseFloat(hourMatch[1]) : 0;
    const minutes = minuteMatch ? parseFloat(minuteMatch[1]) : 0;
    const seconds = secondMatch ? parseFloat(secondMatch[1]) : 0;
    return (hours * 60) + minutes + (seconds / 60);
  }

  if (trimmedDuration.includes(":")) {
    const parts = trimmedDuration.split(":").map((value) => parseInt(value, 10));

    if (parts.every((value) => !Number.isNaN(value))) {
      if (parts.length === 3) {
        return (parts[0] * 60) + parts[1] + (parts[2] / 60);
      }

      if (parts.length === 2) {
        return parts[0] + (parts[1] / 60);
      }
    }
  }

  const numericDuration = parseFloat(trimmedDuration);
  return Number.isNaN(numericDuration) ? 0 : numericDuration;
};

const hasWorkedDuration = (durationValue) => parseDurationToMinutes(durationValue) > 0;

const getDisplayAttendanceStatus = ({
  status,
  date,
  firstInTime,
  totalDuration,
  hours,
}) => {
  const normalizedStatus = normalizeStatusLabel(status);
  const isWeekOffStatus = normalizedStatus.toLowerCase() === "week off";

  if (!isWeekOffStatus) {
    return normalizedStatus;
  }

  const workedOnWeekend = isWeekendDate(date) && (
    hasClockInTime(firstInTime) ||
    hasWorkedDuration(totalDuration) ||
    hasWorkedDuration(hours)
  );

  return workedOnWeekend ? WEEKEND_STATUS_LABEL : normalizedStatus;
};

export {
  WEEKEND_STATUS_LABEL,
  getDisplayAttendanceStatus,
  hasWorkedDuration,
  isWeekendDate,
  normalizeStatusLabel,
};
